import { CSSProperties } from "react";
import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const OnboardingContainer = styled.header`
  position: fixed;
  display: flex;
  z-index: 999;
  width: 100vw;
  height: 88px;
  justify-content: space-between;
  align-items: center;
`;

export const MainContainer = styled.header`
  position: fixed;
  display: flex;
  z-index: 999;
  width: 100vw;
  height: 76px;
  align-items: center;
  padding-left: ${constants.divPadding}px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
`;

export const HeaderItemListContainer = styled.div`
  margin-left: ${constants.divPadding}px;
  display: flex;
  flex-direction: row;
`;

export const HeaderItemContainer = styled.div`
  margin-left: ${spacing.xxs}px;
  height: 36px;
  display: flex;
  align-items: center;
  padding: 0 ${spacing.m}px;
  border-radius: 999px;
  user-select: none;
  cursor: pointer;
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    header: {
      backgroundColor: theme.header.background,
    },
    selected: {
      backgroundColor: theme.header.item.selected,
    },
    right: {
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: constants.divPadding,
    },
    headerItem: {
      fontWeight: 500,
    },
    selectedText: {
      color: theme.header.item.text,
    },
    headerLogo: {
      cursor: "pointer",
      userSelect: "none",
    },
  };

  return styles;
};
